export default {
  login: "hrmis/auth/login",
  requestCredentials: "hrmis/auth/requestCredentials",
  setPassword: "hrmis/auth/setPassword",
  logout: "hrmis/auth/logout",
  resetPassword: "hrmis/auth/resetPassword",
  company: "company",
  companies: "company/companies",
  setCompany: "hrmis/auth/setCompany",
  verifyOTP: "hrmis/auth/2fa/verify",
  resendOTP: "hrmis/auth/2fa/resend",
  otp_minutes: "hrmis/auth/2fa/otp_minutes",
};
